query EntityDocument($documentId: UUID!) {
  entityDocument(id: $documentId) {
    id
    _downloadLink
    fileIndexInformation
    _documentContents
    comment
    entityDocumentTypeId
    indexTransactionDate
    indexName
    indexDescription
    indexReferenceNumber
    indexAmount
    indexCurrencyId
    extractionTypeId
    fileReference
    _fileType
    _fileViewer
    _rowTimestamp
  }
}
